	
    export enum TipoTicketEnum {
    CORRECAO_ERRO = "CORRECAO_ERRO",
    DEMANDA_TECNICA = "DEMANDA_TECNICA",
    MELHORIA_SUGESTAO = "MELHORIA_SUGESTAO",
    ATENDIMENTO_REALIZADO_CLIENTE = "ATENDIMENTO_REALIZADO_CLIENTE"
    }

    export const DescricaoTipoTicket = new Map<TipoTicketEnum, string>([
        [TipoTicketEnum.CORRECAO_ERRO, "Correção de Erro"],
        [TipoTicketEnum.DEMANDA_TECNICA, "Demanda Técnica"],
        [TipoTicketEnum.MELHORIA_SUGESTAO, "Melhoria/Sugestão"],
        [TipoTicketEnum.ATENDIMENTO_REALIZADO_CLIENTE, "Atendimentos Realizados ao Cliente"]
    ]);

    /** Cor de identificação do card no Kanban (borda/faixa). */
    export const CorTipoTicket = new Map<TipoTicketEnum, string>([
        [TipoTicketEnum.CORRECAO_ERRO, '#E53935'],
        [TipoTicketEnum.DEMANDA_TECNICA, '#1E88E5'],
        [TipoTicketEnum.MELHORIA_SUGESTAO, '#8E24AA'],
        [TipoTicketEnum.ATENDIMENTO_REALIZADO_CLIENTE, '#00897B']
    ]);